import { Box } from '@mui/material';
import { RotorElement } from '../../generalComponents/rotorElement/RotorElement';
import { PumpWithoutPropeler } from 'src/assets/widgets/PumpWithoutPropeler';

type Props = {
  width?: number;
  height?: number;
  isAlarmActive: boolean;
  isRunning: boolean;
};

export const SpinningPump = ({ width, height, isRunning, isAlarmActive }: Props) => {
  const widthOfElement = width ?? 180;
  const heightOfElement = height ?? 380;

  const lighRedColor = '#ffdad9';

  let testId = 'offState';

  if (isAlarmActive) {
    testId = `activeAlarm-${isRunning ? 'onState' : 'offState'}`;
  } else if (isRunning && !isAlarmActive) {
    testId = 'onState';
  }

  return (
    <Box position="relative" width="fit-content" height="fit-content" data-sm={testId}>
      <PumpWithoutPropeler
        width={widthOfElement}
        height={heightOfElement}
        fill={isAlarmActive ? lighRedColor : '#f4f4f7'}
      />
      <Box sx={{ position: 'absolute', left: '32%', bottom: '10%' }}>
        <RotorElement
          width={widthOfElement * 0.36}
          height={heightOfElement * 0.36}
          isAlarmActive={isAlarmActive}
          isRunning={isRunning}
        />
      </Box>
    </Box>
  );
};
